import { useEffect } from 'react';
import { $document } from '@umu/umu-dom';

/**
 * @author Kody 设置页面 title
 * @param title [string]
 * @author Kody
 */
export const useTitle = (title: string) => {
    useEffect(() => {
        if (title) {
            $document.title = title;
        }
    }, [title]);
};
